@tailwind base;
@tailwind components;
@tailwind utilities;

@layer base {
  :host {
    font-family: inherit;
  }
}
